import { render, staticRenderFns } from "./EditRegister.vue?vue&type=template&id=88e691b0&scoped=true&"
import script from "./EditRegister.vue?vue&type=script&lang=js&"
export * from "./EditRegister.vue?vue&type=script&lang=js&"
import style0 from "./EditRegister.vue?vue&type=style&index=0&id=88e691b0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e691b0",
  null
  
)

export default component.exports